import { render, staticRenderFns } from "./PleatedDrapery.vue?vue&type=template&id=53837757&scoped=true&"
import script from "./PleatedDrapery.vue?vue&type=script&lang=js&"
export * from "./PleatedDrapery.vue?vue&type=script&lang=js&"
import style0 from "./PleatedDrapery.vue?vue&type=style&index=0&id=53837757&scoped=true&lang=css&"
import style1 from "./PleatedDrapery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53837757",
  null
  
)

export default component.exports